<template>
	<app-page>
		<app-heading title="Survey Result" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="primary">Save</app-button>
					<app-button
						type="cancel"
						small
						:to="{ name: 'market-survey-results' }"
					>
						Cancel
					</app-button>
				</app-section-actions>
				<input-text
					type="number"
					label="Score"
					step="0.5"
					max="5"
					min="1"
					v-model="result.score"
					:errors="errors.score"
				/>
				<input-text
					type="number"
					label="Revenue"
					v-model="result.revenue"
					:errors="errors.revenue"
				/>
				<input-text
					type="number"
					label="Occupany Rate"
					v-model="result.occupancy_rate"
					:errors="errors.occupancy_rate"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			this.result = await this.$ravello.request()
				.v(2)
				.to('markets')
				.to(this.marketId)
				.to('surveys')
				.to(this.surveyId)
				.to('results')
				.to(this.id)
				.get()
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			result: {
				score: 0,
				revenue: 0,
				occupancy_rate: 0,
			},
			errors: {},
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
		surveyId() {
			return this.$route.params.survey
		},
		id() {
			return this.$route.params.result
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')

			try {
				await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('surveys')
					.to(this.surveyId)
					.to('results')
					.to(this.id)
					.update({
						score: this.result.score,
						revenue: this.result.revenue,
						occupancy_rate: this.result.occupancy_rate,
					})

				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', 'Result successfully updated')
				this.$router.push({ name: 'market-survey-results' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
